<template>
  <div>
    <!--begin::Content header-->
    <div style="display:none"
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        ¿Aún no tienes una cuenta?
      </span>
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'register' }"
      >
      !Regístrate!
      </router-link>
    </div>
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Registro como nuevo usuario</h3>
        <span>Completa el siguiente formulario</span>
        </div>

        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <div class="form-label-group">
          <label for="example-input-1">Rut Empresa</label>
          <b-form-input
            class="form-control"
            id="example-input-1"
            name="example-input-1"
            :readonly="step2"
            v-model="$v.form.rutEmpresa.$model"
            :state="validateState('rutEmpresa')"
            aria-describedby="input-1-live-feedback" autofocus
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            Rut es requerido y debe ser valido.
          </b-form-invalid-feedback>
        </div>
        <div class="form-label-group">
          <label for="example-input-2">Numero documento</label>
          <div role="wrapper" class="gj-datepicker gj-datepicker-bootstrap gj-unselectable input-group">
            <b-form-input
            class="form-control"
            id="example-input-2"
            name="example-input-2"
            :readonly="step2"
            v-model="$v.form.numeroDocumento.$model"
            :state="validateState('numeroDocumento')"
            aria-describedby="input-2-live-feedback" autofocus
          ></b-form-input>
            <span class="input-group-append" role="right-icon">
              <button id="help_document" class="btn btn-outline-secondary border-left-0" type="button">
                <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="question circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-question-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M5.25 6.033h1.32c0-.781.458-1.384 1.36-1.384.685 0 1.313.343 1.313 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.007.463h1.307v-.355c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.326 0-2.786.647-2.754 2.533zm1.562 5.516c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"></path></g></svg>
                </button></span></div>
                <b-popover target="help_document" triggers="hover" placement="top">
                  <template v-slot:title>Número de documento</template>
                  Debes ingresar un numero de documento que hallas emitido en los últimos 6 meses.
                  Esto nos permitirá validar y crear una cuenta para que puedas ingresar al portal de pagos.
                </b-popover>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Contraseña es requerida.
          </b-form-invalid-feedback>
        </div>

        <!--begin::Action-->
         <button  v-show="!step2"
            ref="kt_login_signin_submit" style="margin-left:45%"
            class="btn btn-primary align-self-center"
          >
            Continuar
          </button>

       <div class="form-label-group" v-show="step2">
          <label for="example-input-1">Rut Cliente</label>
          <b-form-input
            class="form-control"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.formFull.rutCliente.$model"
            :state="validateStateFull('rutCliente')"
            aria-describedby="input-rut-live-feedback" autofocus
          ></b-form-input>
          <b-form-invalid-feedback id="input-rut-live-feedback">
            Rut es requerido y debe ser valido.
          </b-form-invalid-feedback>
        </div>
        <div class="form-label-group" v-show="step2">
          <label for="example-input-3">Nombres</label>
          
          <b-form-input
            class="form-control"
            type="text"
            id="example-input-3"
            name="example-input-3"
            v-model="$v.formFull.nombres.$model"
            :state="validateStateFull('nombres')"
            aria-describedby="input-3-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-3-live-feedback">
            Nombre es requerido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group" v-show="step2">
          <label for="example-input-4">Apellidos</label>
          
          <b-form-input
            class="form-control"
            type="text"
            id="example-input-4"
            name="example-input-4"
            v-model="$v.formFull.apellidos.$model"
            :state="validateStateFull('apellidos')"
            aria-describedby="input-4-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-4-live-feedback">
            Apellidos es requerido.
          </b-form-invalid-feedback>
        </div>
        <div class="form-label-group" v-show="step2">
          <label for="example-input-5">Email</label>
          <b-form-input
            class="form-control"
            type="email"
            id="example-input-5"
            name="example-input-5"
            v-model="$v.formFull.email.$model"
            :state="validateStateFull('email')"
            aria-describedby="input-5-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-5-live-feedback">
            Email es requerido.
          </b-form-invalid-feedback>
        </div>
       
         <button  v-show="step2"
            ref="kt_register_signin_submit" 
            class="btn btn-primary align-self-center"
          >
            Registrarse
          </button>

        <p class="mt-3 mb-3 text-muted text-center">
          <a
            href="#"
            v-on:click="$router.push('login')"
            class="text-dark-60 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
           Ya tengo una cuenta {{step2}}
          </a>
         
        </p>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import { ACCOUNT_VALIDATE, ACCOUNT_CREATE } from "@/core/services/store/account.module";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "register",
  data() {
    return {
      step2:false,
      // Remove this dummy login info
      form: {
        rutEmpresa: "96776000-5",
        rutCliente:"",
        numeroDocumento: "",
        nombres:"",
        apellidos:"",
        email:""
      },
      formFull: {
        rutEmpresa: "96776000-5",
        rutCliente:"",
        numeroDocumento: "",
        nombres:"",
        apellidos:"",
        email:""
      }
    };
  },
  validations: {
    form: {
      rutEmpresa: {
        required,
       // rut
      },
      numeroDocumento: {
        required,
        minLength: minLength(3)
      }
    },
    formFull: {
      
      rutCliente: {
        required,
       // rut
      },
      nombres: {
        required,
        minLength: minLength(3)
      },
      apellidos: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Hemos validado correctamente la información.
          Ahora completa tu nombre, apellido y email para darte de alta.`, {
        title: 'Te hemos validado',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateFull(name) {
      const { $dirty, $error } = this.$v.formFull[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rutEmpresa: null,
        rutCliente:null,
        numeroDocumento: null,
        nombres:null,
        apellidos:null,
        email:null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      console.log('step2 '  + this.step2);
      if(!this.step2){
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        this.verificaCuenta();
      } else {
        console.log('step2 crearCuenta');
        this.$v.formFull.$touch();
        if (this.$v.formFull.$anyError) {
          return;
        }
        console.log('step2 crearCuenta 2');
        this.crearCuenta();
      }
    },
    verificaCuenta(){
      const rutEmpresa = this.$v.form.rutEmpresa.$model;
      const numeroDocumento = this.$v.form.numeroDocumento.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(ACCOUNT_VALIDATE, { rutEmpresa, numeroDocumento })
          // go to which page after successfully login
          .then(() => this.makeToast(), this.step2 = true);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    },
    crearCuenta(){
      const rutEmpresa = this.$v.form.rutEmpresa.$model;
      const numeroDocumento = this.$v.form.numeroDocumento.$model;
      const rutCliente = this.$v.formFull.rutCliente.$model;
      const nombres = this.$v.formFull.nombres.$model;
      const apellidos = this.$v.formFull.apellidos.$model;
      const email = this.$v.formFull.email.$model;
      
      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_register_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(ACCOUNT_CREATE, { rutEmpresa, numeroDocumento, rutCliente, nombres, apellidos, email })
          // go to which page after successfully login
          .then(() => this.makeToast(), this.step2 = true);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    }

  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
